<script lang="ts">
  type Tone = "accent" | "muted" | "campaign" | "error";

  interface Props {
    tone?: Tone;
    children?: import("svelte").Snippet;
    class?: string;
  }

  let { tone = "muted", children, class: className = "" }: Props = $props();

  // Tones own text size/color here on the wrapper (one text-* per element) —
  // sized <span>s at call sites hit the CSS emission-order lottery that
  // tests/static/text-markup.spec.ts guards against.
  const tones: Record<Tone, string> = {
    accent: "bg-Purple200 text-Neutral900",
    muted: "bg-Neutral200 text-Neutral900",
    campaign: "bg-PurplePrimary text-Neutral100 text-M",
    error: "bg-Purple700 text-white text-sm font-bold",
  };
</script>

<div role={tone === "error" ? "alert" : undefined} class="px-4 py-3 {tones[tone]} {className}">
  {@render children?.()}
</div>
